import React from 'react'
import BackIcon from "../../assets/images/BackIcon.svg";
import { gtmPush } from '../../analytics/useGtmPageview.tsx';

const BackButton = ({onClick,text,type="button"}) => {

  const handleClick = (e) => {
    // ✅ Push event to GTM
    gtmPush("button_click", {
      elementId: "back-button",
      button_text: text,
      page_path: window.location.pathname + window.location.search,
    });

    // ✅ Call the parent’s onClick if provided
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button className="step-btn back-btn" onClick={handleClick} type={type}>
          <img src={BackIcon} alt='' />
          {text}
        </button>
  )
}

export default BackButton